import { useState, useMemo } from "react";

import Table from "../../generic_components/Table/Table";

const OfflineErrorMsg = ({ serverName, newlyOfflineCam }) => {
    const [expanded, setExpanded] = useState(false); 

    const handleToggle = () => {
        setExpanded(!expanded);
    }

    const utcStrToLocal = (utcTimestamp) => {
        // Create a Date object using the UTC timestamp
        const utcDate = new Date(utcTimestamp);

        // Get the local time components
        const localYear = utcDate.getFullYear();
        const localMonth = utcDate.getMonth() + 1; // Months are zero-based
        const localDay = utcDate.getDate();
        const localHours = utcDate.getHours();
        const localMinutes = utcDate.getMinutes();
        const localSeconds = utcDate.getSeconds();
        // Create a new Date object with the local time components
        const localDate = new Date(localYear, localMonth - 1, localDay, localHours, localMinutes, localSeconds);
        // Format the local time as needed
        const formattedLocalTime = localDate.toLocaleString();
        return formattedLocalTime
    }

    // Headers for offline devices table
    const newlyOfflineCams_columns = useMemo(() => [
        { key: 'cameraName', label: 'Camera Name' },
        { key: 'offlineSince', label: 'Offline Since' },
    ], []);

    // Filter out all offline cameras
    const newlyOfflineCams_data = useMemo(() => {    
      return newlyOfflineCam.map((device) => ({
          cameraName: device?.cameraName,
          offlineSince: (device?.cameraOfflineSince === 'N/A' ? 'N/A' : utcStrToLocal(device?.cameraOfflineSince)),
        }))
    }, [newlyOfflineCam]);

    return (
        <div>
            <p>
                <b>{newlyOfflineCam.length}</b> camera{newlyOfflineCam.length > 1 ? 's' : ''} attached to Server <b>{serverName}</b> just went offline.
            </p>
            <button 
            className='view-offline-cams-btn'
            onClick={() => {
                handleToggle();
            }}
            >
            {!expanded ? 'View': 'Hide'} all {newlyOfflineCam.length} device{newlyOfflineCam.length > 1 ? 's' : ' '} <i className={`fa-solid fa-angle-down submenu-icon ${expanded ? 'open' : ''}`}></i>  
            </button>

            {
            expanded && (
                <Table
                    columns={newlyOfflineCams_columns}
                    data={newlyOfflineCams_data}
                    tableStyle={{minWidth: 0}}
                    thStyle={{fontSize: '10px'}}
                    tdStyle={{fontSize: '10px', color: 'black'}}
                />
            )
            }
        </div>
    )
}

export default OfflineErrorMsg;